import React from 'react';
import agent from '../../agent';
import GenericInput from '../GenericInput';
import LoadingIndicator from '../LoadingIndicator';
import { GOTOPAGE, TABLE_COLUMNS_LOADED } from '../../constants/actionTypes';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { wait } from '../../utils';
import cache from '../../cache';

const mapStateToProps = state => ({
  tables: state.tables,
  isLocalDbGood: state.common.isLocalDbGood
});

const mapDispatchToProps = dispatch => ({
  gotoPage: payload =>
    dispatch({ type: GOTOPAGE, payload }),
  updateColumns: payload =>
    dispatch({ type: TABLE_COLUMNS_LOADED, payload }),
});


class ViewRecord extends React.Component {
  constructor() {
    super();

    this.state = { 
      table: {
        columns: []
      },
      data: {},
      isInitialized: false,
      showLoading: true,
    };
    this.initializeView = this.initializeView.bind(this);
    this.deleteRecord = this.deleteRecord.bind(this);
    this.refreshRecord = this.refreshRecord.bind(this);
    this.waitForLocalDb = this.waitForLocalDb.bind(this);
  }

  async waitForLocalDb(time) {
    for(let i = 0; i < 5; i++) {
      if(this.props.isLocalDbGood) {
        break;
      }else {
        await wait(time/5);
      }
    }
  }

  async initializeView(tableId) {
    await this.waitForLocalDb(100);
    let record;
    if(this.props.isLocalDbGood) {
      record = await cache.getRecord(tableId, this.props.match.params.dataId);
    }
    if(record && record.id) {
      this.setState({isInitialized: true, showLoading: false, data: record});
    }else {
      this.refreshRecord();
    }
  }

  async refreshRecord() {
    let {tableId, dataId} = this.props.match.params;
    this.setState({showLoading: true});
    let refreshedObj = await agent.Data.getSingleRow(tableId, dataId)
      .catch(err => {
        this.setState({showLoading: false});
        console.log(err);
      })
    this.setState({isInitialized: true, showLoading: false, data: refreshedObj});
    cache.saveRecord(tableId, refreshedObj);
  }

  deleteRecord() {
    let {tableId, dataId} = this.props.match.params;
    agent.Data.deleteRow(tableId, dataId)
      .then(res => {
        cache.deleteRecord(tableId, dataId);
        this.props.gotoPage(`/table/${tableId}/list`);
      })
  }

  static getDerivedStateFromProps(props, state) {
    let { isInitialized } = state;
    if(state.table.id !== props.match.params.tableId) {
      isInitialized = false;
    }
    if (props.tables && props.tables.length > 0 && !isInitialized) {
      let currentTable = state.table;
      props.tables.forEach(table => {
        if(props.match.params.tableId === table.id) {
          currentTable = Object.assign({}, table);
          isInitialized = true;
        }
      });
      const newState = Object.assign({}, state, {isInitialized, table: currentTable, data: {}});
      return newState;
    }
    return null;
  }

  componentDidMount() {
    this.initializeView(this.state.table.id);
  }

  componentDidUpdate(prevProps) {
    if((this.state.table.id && this.state.table.id !== prevProps.match.params.tableId) || 
       (this.state.data.id && this.state.data.id !== prevProps.match.params.dataId)) {
      this.initializeView(this.state.table.id);
    }
  }

  render() {
    return (
      <div className="container">
        <div>
          <br/>
          <Link to={'/table/'+this.state.table.id+'/list'} className="btn btn-outline-primary">View All</Link>&nbsp;
          <button onClick={this.refreshRecord} className="btn btn-outline-primary float-right">Refresh</button>
          <div className="clearfix"/><br/>
          <LoadingIndicator isShow={this.state.showLoading}/>
          <table className="table table-striped table-bordered table-hover">
            <thead>
              {this.state.isInitialized &&
                <tr>
                  <th>Field</th>
                  <th>Value</th>
                </tr>
              }
            </thead>
            <tbody>
                {this.state.isInitialized &&
                  this.state.table.columns.map(column => 
                    <tr key={column.name}>
                      <td>{column.label}</td>
                      <td>
                        {this.state.data[column.name] ? this.state.data[column.name].toString() : ''}
                      </td>
                    </tr>
                  )}
            </tbody>
          </table>
          <Link to={'/table/'+this.state.table.id+'/'+this.state.data.id+'/edit'} className="btn btn-primary">Edit</Link>&nbsp;
          <button onClick={this.deleteRecord} className="btn btn-danger">Delete</button>&nbsp;
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewRecord);
